import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Wordmark from "@/components/Wordmark";
import { LogIn, ShieldCheck, BarChart3, Users } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between p-12 text-white relative overflow-hidden"
        style={{ background: "linear-gradient(160deg,#081226,#0f2042 60%,#081226)" }}>
        <Wordmark />
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-tight">Command center for your <span className="text-[#E8752A]">club</span>.</h1>
          <p className="text-slate-300 mt-4 max-w-sm">Track every visitor, lead, and conversion in real time. Built for Oneiros Varachha.</p>
          <div className="mt-8 space-y-3 text-sm text-slate-300">
            {[[ShieldCheck, "Role-based secure access"], [BarChart3, "Live analytics & funnels"], [Users, "Lead & follow-up management"]].map(([Icon, t], i) => (
              <div key={i} className="flex items-center gap-3"><Icon size={18} className="text-[#E8752A]" /> {t}</div>
            ))}
          </div>
        </div>
        <p className="text-xs text-slate-500">© 2026 Oneiros Varachha</p>
      </div>

      <div className="flex items-center justify-center p-8 bg-[#F4F6F9]">
        <div className="w-full max-w-sm bg-white rounded-3xl shadow-xl border border-slate-100 p-8">
          <div className="md:hidden flex justify-center mb-6"><Wordmark dark /></div>
          <h2 className="font-display text-2xl font-extrabold text-[#081226]">Team Login</h2>
          <p className="text-sm text-slate-500 mt-1 mb-8">Sign in to access the dashboard.</p>
          <button data-testid="google-login-btn" onClick={handleLogin}
            className="w-full h-14 rounded-2xl font-bold text-white flex items-center justify-center gap-3 transition-transform active:scale-[0.99] shadow-lg"
            style={{ background: "linear-gradient(135deg,#FFA14D,#E85D1F)" }}>
            <LogIn size={20} /> Continue with Google
          </button>
          <p className="text-xs text-slate-400 mt-6 text-center">Access is role-based. Contact your admin if you need permissions.</p>
        </div>
      </div>
    </div>
  );
}
